import _ from '@/utils/lodash-optimized'
import moment from 'moment'
import SystemRoles from 'shared_src/dictionaries/roles/SystemRoles'

import groups from './Codes/groups'

const wrap = (name, value, wrappers, context) => {
  const wrapper = wrappers[name]
  return (wrapper && wrapper(value, context)) || value
}

const renderDiff = (change, wrappers, context) => {
  const oldWrap = wrap(change.name, change.old, wrappers, context)
  const newWrap = wrap(change.name, change.new, wrappers, context)
  if (!oldWrap && newWrap) {
    return <span className='nh-add'>{newWrap}</span>
  }
  if (oldWrap && !newWrap) {
    return <span className='nh-delete'>{oldWrap}</span>
  }
  if (oldWrap && newWrap && oldWrap !== newWrap) {
    return (
      <span className='nh-change'>
        {oldWrap}
        {' '}
        &rarr;
        {' '}
        {newWrap}
      </span>
    )
  }
  return null
}

const renderChange = (change, wrappers, context) => {
  const diff = renderDiff(change, wrappers, context)
  if (diff) {
    return (
      <div
        className='pure-u-1-1 col-xs-4'
        key={change.description}
      >
        <div className='nh-data-element'>
          <b>{change.description}</b>
          {' '}
          {diff}
        </div>
      </div>
    )
  }
  return null
}

export const render = (key, changes, wrappers, context) => {
  const body = _.compact(
    changes.map(change => renderChange(change, wrappers, context))
  )
  if (_.isEmpty(body)) {
    return (
      <div
        className='nh-card-changes no-changes'
        key={key}
      >
        No actual changes
      </div>
    )
  }
  return (
    <div
      className='nh-card-changes'
      key={key}
    >
      {body}
    </div>
  )
}

const wrapBool = value => (value && 'Yes') || 'No'

const wrapUser = (value, context) =>
    (context?.users ?? {})[value] || value

const wrapClient = (value, context) =>
    (context?.clients ?? {})[value] || value

const wrapOrganization = (value, context) =>
    (context?.organizations ?? {})[value] || value

const wrapPartner = (value, context) =>
    (context?.partners ?? {})[value] || value

export const wrappers = {
  user_metadata: {
    onduty: wrapBool,
    monitoring: wrapBool,
    oncall: wrapBool,
    concierge: wrapBool,
    role: value =>
        SystemRoles.find(r => r.value === value)?.label ?? value
      ,
    organizations: (value, context) =>
      (value || [])
        .sort()
        .map(o => wrapOrganization(o, context))
        .join(', '),
    enabled: wrapBool,
    organization: wrapPartner,
    supervisor: wrapUser,
    director: wrapUser,
    practitioner_notifications: wrapBool,
    quality_lead: wrapBool,
    igao: wrapBool,
    trend: wrapBool,
    behavioral: _.capitalize,
    mobile_management: _.capitalize,
    group: value => groups.find((group) => group.value === value)
      ?.label || value,
    prn: wrapBool

  },
  settings: {
    sunday: wrapBool,
    monday: wrapBool,
    tuesday: wrapBool,
    wednesday: wrapBool,
    thursday: wrapBool,
    friday: wrapBool,
    saturday: wrapBool,
    start: value => moment(value)
      .format('HH:mm'),
    end: value => moment(value)
      .format('HH:mm'),
    billing: value =>
      (value && moment(value)
        .format('MM/DD/YYYY HH:mm')) || null
  },
  document: {
    patientId: value =>
      (value
        ? <a href={`/patient/${value}/patientFolder`}>{value}</a>
        : null),
    clientName: wrapClient
  }
}
